export function isProductionEnvironment() {
  return (
    import.meta.env.VITE_API_URL?.startsWith("https://api") &&
    import.meta.env.VITE_API_URL?.endsWith("peanuts.nl")
  )
}

export function isAcceptanceEnvironment() {
  const apiUrl = import.meta.env.VITE_API_URL
  return (
    (apiUrl?.startsWith("https://dev.") && apiUrl.endsWith("peanuts.nl")) ||
    /^https:\/\/[^./]+\.pnts\.dev(?:\/|$)/.test(apiUrl ?? "")
  )
}

export function isLocalEnvironment() {
  return import.meta.env.VITE_API_URL?.startsWith("http://localhost")
}
